module.exports = __webpack_public_path__ + "img/e_voucher_logo_white.5ca2a292.svg";